import { atom } from 'jotai';

import type { hometaxBlockSettingsQuery$data } from '@/__generated__/hometaxBlockSettingsQuery.graphql';

export const hometaxBlockSettingsAtom = atom<{
  data: hometaxBlockSettingsQuery$data['hometaxBlockSettings'] | null;
  loading: boolean;
  lastFetched: number | null;
}>({
  data: null,
  loading: false,
  lastFetched: null
});
